import * as T from 'three';

// A finger is wide and a character is thin: a tap counts as on someone when it lands anywhere in a body-sized
// box round where they stand (from their feet to just over their head), not only on the drawn arms and legs.
// Returns how far along the ray the box is hit, or null when the tap misses them.

const HALF_WIDTH = 0.35;
const BOX = new T.Box3();
const HIT = new T.Vector3();

export function bodyHit(ray: T.Ray, feet: T.Vector3, height: number): number | null {
  BOX.min.set(feet.x - HALF_WIDTH, feet.y, feet.z - HALF_WIDTH);
  BOX.max.set(feet.x + HALF_WIDTH, feet.y + height, feet.z + HALF_WIDTH);
  return ray.intersectBox(BOX, HIT) ? ray.origin.distanceTo(HIT) : null;
}
